import { memo } from 'react';

import { ComponentContextProps } from '@/components';
import { Logo, LogoProps } from '@/components/core';
import { EmailIcon } from '@/components/icons';

export type EmailLogoProps = LogoProps & Partial<ComponentContextProps>;

const IEmailLogo = ({ variant, className, ...rest }: EmailLogoProps) => {
  return (
    <Logo variant={variant} className={className} {...rest}>
      <EmailIcon />
    </Logo>
  );
};

export const EmailLogo = memo(IEmailLogo) as typeof IEmailLogo;
